var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackAnimationBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fade",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1800px",
    height: "1200px",
    viewBox: "0 0 1800 1200",
    enableBackground: "new 0 0 1800 1200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -24.273,
    y: -21.243,
    fill: "#212121",
    stroke: "none",
    strokeMiterlimit: 10,
    width: 1842.184,
    height: 1233.123
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F7941E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 127.754,
    cy: 113.781,
    r: 13
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "0s",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 365,
    cy: 249.997,
    r: 22
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: ".2s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 547,
    cy: 387.997,
    r: 18
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: ".4s",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 125,
    cy: 509.997,
    r: 18
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: ".6s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 663.754,
    cy: 125.781,
    r: 14
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: ".8s",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 505.754,
    cy: 595.781,
    r: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "1s",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 521.754,
    cy: 909.781,
    r: 12
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "1.2s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 219.754,
    cy: 1063.781,
    r: 19
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "1.4s",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F7941E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 851,
    cy: 531.997,
    r: 23
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "1.6s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 941,
    cy: 791.997,
    r: 17
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "1.8s",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F7941E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 959.754,
    cy: 235.781,
    r: 16
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "2s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1303.754,
    cy: 151.781,
    r: 22
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "2.2s",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#C49A6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1229.754,
    cy: 521.781,
    r: 16
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "2.4s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1561.997,
    cy: 497,
    r: 20
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "2.6s",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1635.754,
    cy: 147.781,
    r: 18
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "2.8s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 763,
    cy: 1083.997,
    r: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "3s",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#F15A29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1203.754,
    cy: 1035.781,
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "3.2s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#DA1C5C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1409.754,
    cy: 821.781,
    r: 20
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "3.4s",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1661.754,
    cy: 709.781,
    r: 18
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "3.6s",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 1591.754,
    cy: 1017.781,
    r: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "3.8s",
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 163.754,
    cy: 827.781,
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;.6;0",
    begin: "4s",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAnimationBackground);
export default __webpack_public_path__ + "static/media/Black-Animation-Background.2e9377d6fbb1370a1ed46de4729e0c72.svg";
export { ForwardRef as ReactComponent };